// src/app/persistConfig.js
import storage from 'redux-persist/lib/storage';

// Custom storage wrapper with fallback for iOS Chrome and private mode
const createCustomStorage = () => {
  // Detect iOS
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  
  return {
    getItem: async (key) => {
      try {
        const value = await storage.getItem(key);
        return value;
      } catch (error) {
        console.warn(`Failed to get item "${key}" from storage:`, error);
        // Return null to let Redux use initial state
        return null;
      }
    },
    setItem: async (key, value) => {
      try {
        await storage.setItem(key, value);
      } catch (error) {
        console.warn(`Failed to set item "${key}" in storage:`, error);
        // Don't throw - let the app continue even if storage fails
        // This is important for iOS Safari private mode
      }
    },
    removeItem: async (key) => {
      try {
        await storage.removeItem(key);
      } catch (error) {
        console.warn(`Failed to remove item "${key}" from storage:`, error);
      }
    }
  };
};

const persistConfig = {
  key: 'root',
  storage: createCustomStorage(),
  whitelist: ['auth'], // persist only the auth slice
};

export default persistConfig;
